import React, {useState} from "react";
import * as S from './ThemeToggler.styles';

interface ThemeTogglerProps {
  isActive?: boolean;
  onToggle?: () => void;
}


const ThemeToggler: React.FC<ThemeTogglerProps> = ({
  isActive = false,
  onToggle,
}) => {
  const [active, setActive] = useState(isActive);
  const updateToggle = () => {
    setActive(!active);
    onToggle(!active);
  }
  return (
    <S.ThemeTogglerWrapper onClick={() => updateToggle()} isActive={active}>
      <S.Notch isActive={active} />
    </S.ThemeTogglerWrapper>
  );
}

export default ThemeToggler;
